import React from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { reduxForm, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { onCancelCOGSModal } from 'actions/library/item';
import { Link } from 'react-router';
import styles from './COGSModal.css';
import COGSModalFieldArray from './COGSModalFieldArray';

class COGSModal extends React.Component {
  render() {
    const { showCOGSModal, handleSubmit } = this.props;
    return (
      <Modal
        show={showCOGSModal}
        onHide={this._onCancel}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={'Manage Cost of Goods Sold (COGS)'} />
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <table className={`table table-responsive ${styles.table}`}>
              <thead>
                <tr>
                  <th>Variant</th>
                  <th className="text-center">Track COGS</th>
                  <th className="text-center">Avg Cost</th>
                </tr>
              </thead>
              <FieldArray
                component={COGSModalFieldArray}
                name="item_variants"
              />
            </table>
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                className="btn btn-default"
                type="button"
                onClick={this._onCancel}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button className="btn btn-primary" type="submit">
                Confirm
              </button>
            </span>
            <i className={styles['footer-info']}>
              *Use the{' '}
              <Link to="/inventory/purchase_orders" target="blank">
                Purchase Order page
              </Link>{' '}
              to manage Avg Cost
            </i>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _onCancel = () => {
    const { dispatch, previousItemForm } = this.props;
    dispatch(onCancelCOGSModal(previousItemForm));
  };
}

function mapStateToProps(state) {
  const { showCOGSModal, previousItemForm } = state.library.item;
  return {
    showCOGSModal,
    previousItemForm,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: true,
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(COGSModal)
);
